<template>
  <div>
    <Loader :loading="showLoader" />

    <v-toolbar color="#222222" flat dense class="mb-4">
      <v-icon color="#337b52" class="ml-2" size="40" @click="goBack">mdi-arrow-left-bold-circle</v-icon>
      <v-toolbar-title style="font-family: 'Material Design Icons'; font-size: 25px">Restaurants</v-toolbar-title>
      <!-- <img :src="logo" class="toolbar-icon" /> -->
    </v-toolbar>

    <div class="search-bar">
      <v-text-field v-model="searchQuery" label="Suchen Sie nach Ihrem Lieblingsrestaurant"
        prepend-inner-icon="mdi-magnify" variant="solo-inverted" density="compact" class="elegant-search" full-width />
    </div>

    <div class="cards-container">
      <RestaurantCard v-for="(card, index) in filteredCards" :key="index" :card="card" :index="index"
        :getCardImage="getCardImage" :viewPdf="viewPdf" />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import RestaurantCard from '@/components/ChildComponents/RestaurantCard.vue';
import Loader from '@/components/Loader.vue';
import { getToolBarLogo } from '@/assets/Branding/branding.js';

export default defineComponent({
  name: 'RestaurantsView',
  components: { RestaurantCard, Loader },
  setup() {
    const showLoader = ref(false);
    const logo = ref('');
    const router = useRouter();
    const searchQuery = ref('');

    const goBack = () => router.go(-1);

    const cards = ref([
      { text: "Cotidiano", link: "https://www.cotidiano.de/_files/ugd/fa297d_4da52bd3a9254fd5976d356ba0444018.pdf", linkText: "Speisekarte" },
      { text: "Wallter's Bistro & Kontor", link: "https://www.wallters.de/_files/ugd/cc5efd_797c4909925247259038c0c39401cee1.pdf", linkText: "Speisekarte" },
      { text: "Goldbach Restaurant", link: "https://editoruploads.s3.juneapp.com/danielwischer/fef540cfefa0d2ecea5c687b3bd91a12.pdf", linkText: "Speisekarte" },
      { text: "Restaurant Parlament", link: "https://www.parlament-hamburg.de/unsere-karte/", linkText: "Speisekarte" },
      { text: "Ristorante Dolcetto", link: "http://www.dolcetto-hamburg.de/index.php/speisekarte/speisekarte", linkText: "Speisekarte" },
      { text: "Restaurant Rialto", link: "https://restaurantrialto.de/speisen_und_getraenke/speisekarten/abendkarte/", linkText: "Speisekarte" },
      { text: "Restaurant Pfeffersack", link: "https://pfeffersack.restaurant/", linkText: "Speisekarte" },
      { text: "Osteria Enoteca - I Vigneri", link: "https://www.ivigneri.de/wp-content/uploads/2024/04/Speisekarte-03-2024.pdf", linkText: "Speisekarte" },
      { text: "Spaccaforno – Börsenbrücke", link: "https://spaccaforno.de/wp-content/uploads/Spaccoforno_Flyer_Boersenbruecke_16-02-2024_korr-1.pdf", linkText: "Speisekarte" },
      { text: "Le Plat du Jour", link: "https://www.le-plat-du-jour.de/speisekarte/", linkText: "Speisekarte" },
      { text: "Atelier F", link: "https://atelierf.de/wp-content/uploads/2024/04/AtelierF_Menue_24-04.pdf", linkText: "Speisekarte" },
      { text: "Saliba Alsterarkaden", link: "https://saliba.de/speisekarte/", linkText: "Speisekarte" }
    ]);


    const getCardImage = (index) => {
      const images = [
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_1.png'),
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_2.png'),
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_3.png'),
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_4.png'),
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_5.png'),
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_6.png'),
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_7.png'),
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_8.png'),
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_9.png'),
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_10.png'),
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_11.png'),
        require('@/assets/Branding/Artinvest/RestaurantViewPictures/restaurant_12.png'),
      ];
      return images[index];
    };

    const filteredCards = computed(() => {
      return cards.value.filter(card => card.text.toLowerCase().includes(searchQuery.value.toLowerCase()));
    });

    const viewPdf = (link) => window.open(link, '_blank');

    onMounted(async () => {
      showLoader.value = true;
      logo.value = await getToolBarLogo();
      setTimeout(() => { showLoader.value = false; }, 500);
    });

    return {
      showLoader, logo, goBack, searchQuery, cards, getCardImage, filteredCards, viewPdf
    };
  }
});
</script>

<style scoped>
.toolbar-icon {
  height: 30px;
  margin-left: auto;
  margin-right: 16px;
}

.search-bar {
  max-width: 900px;
  margin: 1.5rem auto;
  padding: 0 1rem;
}

.cards-container {
  display: grid;
  gap: 1.5rem;
  padding: 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

@media (min-width: 1024px) {
  .cards-container {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .cards-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 767px) {
  .cards-container {
    grid-template-columns: 1fr;
  }
}
</style>
